module.exports = __webpack_public_path__ + "static/media/holiday-party-catering-3.1d318b06.jpg";